import { FormControl } from "@angular/forms";

export function dominioValidator(control: FormControl) {
  const re = new RegExp(/^(?!.*@)[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})+$/);

  if (control.value != undefined && control.value != '' && !re.test(control.value))
    return {
      dominio: true
    }
  return null;
}

